import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class LogService {
    getListCall(data) {
        return axios.post(API_URL + 'log/list-calls', data, { headers: authHeader() });
    }
    getDetailCall(data) {
        return axios.post(API_URL + 'log/detail-calls', data, { headers: authHeader() });
    }
    getListCallGroup(data) {
        return axios.post(API_URL + 'log/calls-group', data, { headers: authHeader() });
    }
    getListCallUser(data) {
        return axios.post(API_URL + 'log/calls-user', data, { headers: authHeader() });
    }
    getListCallUserDuid(data) {
        return axios.post(API_URL + 'log/calls-duid', data, { headers: authHeader() });
    }
    getListCallUserUid(data) {
        return axios.post(API_URL + 'log/calls-uid', data, { headers: authHeader() });
    }


    getListMessage(data) {
        return axios.post(API_URL + 'log/list-messages', data, { headers: authHeader() });
    }
    getDetailMessage(data) {
        return axios.post(API_URL + 'log/detail-messages', data, { headers: authHeader() });
    }
    getListMessageGroup(data) {
        return axios.post(API_URL + 'log/messages-group', data, { headers: authHeader() });
    }
    getListMessageUser(data) {
        return axios.post(API_URL + 'log/messages-user', data, { headers: authHeader() });
    }
    getListMessageUserSrc(data) {
        return axios.post(API_URL + 'log/messages-src', data, { headers: authHeader() });
    }
    getListMessageUserUid(data) {
        return axios.post(API_URL + 'log/messages-uid', data, { headers: authHeader() });
    }

    getAdvancedSearchMessages(data) {
        return axios.post(API_URL + 'log/advanced-search-messages', data, { headers: authHeader() });
    }
    getAdvancedSearchCall(data) {
        return axios.post(API_URL + 'log/advanced-search-call', data, { headers: authHeader() });
    }

    getListCallsGroup(data) {
        return axios.post(API_URL + 'log/list-group-calls', data, { headers: authHeader() });
    }

    getListCallsGroupDetail(data) {
        return axios.post(API_URL + 'log/detail-group-calls', data, { headers: authHeader() });
    }
}

export default new LogService();
